import { render, staticRenderFns } from "./ModalMessageActions.vue?vue&type=template&id=3acc1d27&scoped=true"
import script from "./ModalMessageActions.vue?vue&type=script&lang=js"
export * from "./ModalMessageActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc1d27",
  null
  
)

export default component.exports